import { async } from "q";
import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../errorActionHandler";
import {
  getAllAssignedDataAction,
  putQueryAction,
  getAllAssignedSupportDataAction,
} from "../../actionCreators/adminActionCreator/myQueryActionCreator";

export const getAllAssignedQueriesActionHandler =
  (queryCategory, epoch, pageSize, setLastQueryData, setLoader, isDeleted = false) =>
    async (dispatch, getState) => {
      setLoader(true);
      return await apis.admin.myQueries
        .getAllAssignedQueries(queryCategory, epoch, pageSize)
        .then((response) => {
          if (response.data === null && isDeleted) {
            setLastQueryData(response.data)
            dispatch(getAllAssignedDataAction(response.data));
            return response;
          } else {
            if (response?.data === null) {
              setLastQueryData(response.data)
              return response;
            }
            else if (epoch > 0) {
              const prevState = getState().myQueryReducer?.queryData;
              dispatch(getAllAssignedDataAction(prevState.concat(response.data)));
              return response;
            } else {
              // const prevState = getState().myQueryReducer?.queryData;
              dispatch(getAllAssignedDataAction(response.data));
              return response;
            }
          }
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    };

export const getAllAssignedSupportQueriesActionHandler =
  (queryCategory, epoch, pageSize, setLastQueryData, setLoader, isDeleted = false) =>
    async (dispatch, getState) => {
      setLoader(true);
      return await apis.admin.myQueries
        .getAllAssignedSupportQueries(queryCategory, epoch, pageSize)
        .then((response) => {
          if (response.data === null && isDeleted) {
            setLastQueryData(response.data);
            dispatch(getAllAssignedSupportDataAction(response.data));
            return response;
          } else {
            if (response?.data === null) {
              setLastQueryData(response.data)
              return response;
            }
            else if (epoch > 0) {
              const prevState = getState().myQueryReducer?.queryDataSupport;
              dispatch(getAllAssignedSupportDataAction(prevState.concat(response.data)));
              return response;
            } else {
              dispatch(getAllAssignedSupportDataAction(response.data));
              return response;
            }
          }
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    };

export const deleteQueryActionHandler = (id) => async (dispatch) => {
  return await apis.admin.myQueries
    .deleteQuery(id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const putQueryActionHandler = (data) => async (dispatch) => {
  return await apis.admin.myQueries
    .putQuery(data)
    .then((response) => {
      // console.log(response?.data?.Replies)
      if (response?.data) {
        // dispatch(getAllAssignedQueriesActionHandler())
      }
      // setData(response?.data?.Replies)
      // dispatch(putQueryAction(response?.data));
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const putUnreadCountActionHandler = (setState) => async (dispatch) => {
  apis.admin.myQueries
    .putUnreadCount()
    .then((response) => {
      setState(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const putIsReadActionHandler = (data, setState) => async () => {
  return await apis.admin.myQueries
    .putIsRead(data)
    .then((response) => {
      // setState(response.data);
      // console.log(response)
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
